<template>
  <div class="column is-half acts-wrapper">
    <div class="document-container columns">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteItem"/>
      <div class="input-data">
        <b-input @change="handleUpdate" placeholder="Название ссылки" v-model="object.name" />
        <b-input @change="handleUpdate" placeholder="https://" v-model="object.url"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DocumentItem',
  data () {
    return {
      updateTimer: null
    }
  },
  props: {
    object: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteNormativeAct', 'updateNormativeAct']),
    handleUpdate () {
      clearTimeout(this.updateTimer)
      this.updateTimer = setTimeout(() => {
        this.updateNormativeAct(this.object)
      }, 500)
    },
    deleteItem () {
      this.deleteNormativeAct(this.object.id)
    }
  }
}
</script>

<style scoped>
.acts-wrapper {
  padding: 20px;
}
.document-container {
  background: #eee;
  padding: 20px;
}
.document-wrapper {
  padding: 15px;
}
.delete-icon {
  margin: 0 20px 0 0;
  height: 28px;
  width: 28px;
  position: initial;
}
.input-data {
  width: 100%;
}
.control {
  margin: 0 0 12px;
}
</style>



// WEBPACK FOOTER //
// NormativeActItem.vue?28cb85e7